<template>
  <info-header-card :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import SampleTypeModel from "@/models/lab/SampleTypeModel";

export default {
  name: "SampleTypeCard",
  components: {
    InfoHeaderCard
  },
  props: {
    sample_type: {
      type: Object,
      default: () => new SampleTypeModel()
    }
  },
  computed: {
    header() {
      return `Sample Type: ${this.sample_type.name}`;
    },
    rows() {
      return [
        {
          label: "Description",
          value: this.sample_type.description
        }
      ];
    }
  }
};
</script>
